import { render } from "./wordDetailTable.vue?vue&type=template&id=5c68158a&scoped=true"
import script from "./wordDetailTable.vue?vue&type=script&lang=js"
export * from "./wordDetailTable.vue?vue&type=script&lang=js"

import "./wordDetailTable.vue?vue&type=style&index=0&id=5c68158a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c68158a"]])

export default __exports__